const EventBus = window.EventBus;
export const VdpSimilars = {
  props: ['vehicles', 'fallbackImage', 'lang'],
  data() {
    return {
      modals: {
        year: '',
        make: '',
        model: '',
        trim: '',
        stocknumber: '',
        price: '',
        visibility: {
          requestInformation: false,
        },
      },
    }
  },
  mounted(){
    EventBus.$on('goToCompare', this.goToCompare);
    this.$nextTick(()=>{
      var lazyImages = [].slice.call(document.querySelectorAll(".vehicle-card .main-img"));
      if ("IntersectionObserver" in window) {
        let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              let lazyImage = entry.target;
              lazyImage.src = lazyImage.dataset.src;
              lazyImageObserver.unobserve(lazyImage);
            }
          });
        });
    
        lazyImages.forEach(function(lazyImage) {
          lazyImageObserver.observe(lazyImage);
        });
      } else {
        // Possibly fall back to event handlers here
      }
    })
  },
  methods: {
    down() {
      if (this.page > 1)
        this.goToPage(this.page - 1);
    },
    goToPage(p) {
      var url = window.location.href;
      var explodedUrl = url.split('?');
      url = explodedUrl[0] + '?pag=' + p;
      window.location.replace(url);
    },
    goToCompare(id) {
      console.log("Llego"+id);
      let compare;
      if (!localStorage.compare) {
        var Obj = {
          ids: [id],
        }
        localStorage.setItem('compare', JSON.stringify(Obj));
      }
      else {
        compare = JSON.parse(localStorage.compare);

        if (compare.ids.indexOf(id) == -1)
          compare.ids.push(id);

        if (compare.ids.length > 4) {
          compare.ids.splice(0, 1);
        }
        localStorage.compare = JSON.stringify(compare)
      }

      compare = JSON.parse(localStorage.compare);

      var urlIds = [];
      var j = 0;
      for (var i = compare.ids.length - 1; i >= 0; i--) {
        if (j >= 4)
          break;

        urlIds.push(compare.ids[i]);
        j++;
      }

      window.location.href = '/compare/?vehicles=' + urlIds.join('|');
    },
    showRequestInformationModal(vehicleId) {
      var vehicle = this.vehicles.find(vehicle => vehicle.id === +vehicleId);
      this.modals.year = vehicle.year;
      this.modals.make = vehicle.make;
      this.modals.model = vehicle.model;
      this.modals.trim = vehicle.trim;
      this.modals.stocknumber = vehicle.stocknumber;
      this.modals.price = vehicle.price.toLocaleString('en-US');
      this.modals.visibility.requestInformation = true;
    },
    hideRequestInformationModal() {
      this.modals.visibility.requestInformation = false;
    },
    imgLoadOnError(index) {
      this.$refs['img_' + index].src = this.fallbackImage;
    },
    up() {
      if (this.page < this.pages)
        this.goToPage(this.page + 1);
    },
  },
  computed: {
    getPaginate() {
      var currentGroup = Math.ceil(this.page / this.maxPages);
      //console.log(currentGroup);
      var arrayPage = []
      var from = ((currentGroup - 1) * this.maxPages) + 1;
      var to = (from + this.maxPages) - 1;

      if (to > this.pages)
        to = this.pages;

      this.from = from;
      this.to = to;

      for (let a = from; a <= to; a++) {
        arrayPage.push(a)
      }

      return arrayPage
    },
  },
  filters: {
    moneyFormat:(price, lang)=>{
      var formatter = new Intl.NumberFormat(lang, {
        style: 'currency',
        currency: 'CAD',
        minimumFractionDigits: 0,
      });
      return formatter.format(Math.floor(price));
    }
  }
};